module.exports = __webpack_public_path__ + "static/media/PWID-X-01.cc35f425.png";